// firebase-inappmessaging-custom-display 已處理 web, 因此可直接導入
import FIAM from 'firebase-inappmessaging-custom-display';
import { Component } from 'react';
import { Linking, Platform } from 'react-native';
import safeAwait from 'safe-await';

import { isIOS } from '../../../boot/utils';
import { isWebPlatform } from '../../../boot/utils';
import { AnalyticsEvent } from '../../../constants/AnalyticsEvent';
import type { WithIsFocusedProps } from '../../../decorators/withIsFocused';
import { SetGuideStatusPayload } from '../../../redux/actions/tutorialGuideActions';
import { getDeferredAppLink } from '../../../utils/packages/fbsdk';
import { requestNotiPermission } from '../../../utils/pushNotification/handlePushNotification';
import TrackingTransparencyPermission from './TrackingTransparencyPermission';

interface Props extends WithIsFocusedProps {
  setIsFromDeepLink: (isFromDeepLink: boolean) => void;
  isViewedHome: boolean;
  setGuideStatus: (args: SetGuideStatusPayload) => void;
  setViewedHome: () => void;
}

interface State {
  requestNotiPermissionDone: boolean;
}

export default class PopupGroup extends Component<Props> {
  state: State = {
    requestNotiPermissionDone: isWebPlatform,
  };

  private osVersion = +Platform.Version;
  private canShowATTPopup = isIOS && this.osVersion >= 14.5;

  componentDidMount() {
    const { isViewedHome } = this.props;
    const { requestNotiPermissionDone } = this.state;

    if (!requestNotiPermissionDone) {
      const setRequestNotiPermissionDone = () => {
        this.setState({ requestNotiPermissionDone: true });
      };

      requestNotiPermission({
        done: setRequestNotiPermissionDone,
        // 因 isViewedHome 是記錄用戶是否曾 view 過首頁，且它是存在 memberReducer，有被 persist，故該值也意味著是否安裝後的第一次開啟。
        isFirstLaunch: !isViewedHome,
      });
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { isFocused } = this.props;

    // checkShowGuide if back to homePage
    if (!prevProps.isFocused && isFocused) {
      this.showViewHomeMessage();
    }
  }

  showViewHomeMessage = () => {
    const { isViewedHome, setViewedHome } = this.props;

    /**
     * triggerEvent will do nothing on web.
     */
    FIAM.triggerEvent(AnalyticsEvent.ViewHome);
    setViewedHome();

    if (isViewedHome && this.canShowATTPopup) {
      FIAM.triggerEvent(AnalyticsEvent.RevisitHome);
    }
  };

  checkDeepLinkBeforeCall = async callBack => {
    const { setIsFromDeepLink } = this.props;
    const [, initialUrl] = await safeAwait(Linking.getInitialURL());
    const [, deferredAppLink] = await safeAwait(getDeferredAppLink());
    const hasDeepLink = initialUrl || deferredAppLink;

    if (hasDeepLink) {
      setIsFromDeepLink(true);
    } else {
      callBack();
    }
  };

  checkATTPermissionDone = () => {
    if (isWebPlatform) {
      this.showViewHomeMessage();
    } else {
      this.checkDeepLinkBeforeCall(this.showViewHomeMessage).catch(e =>
        console.log('checkDeepLinkBeforeCall error', e)
      );
    }
  };

  render() {
    const { requestNotiPermissionDone } = this.state;

    if (!requestNotiPermissionDone) {
      return null;
    }

    return (
      <TrackingTransparencyPermission
        canShowATTPopup={this.canShowATTPopup}
        checkDone={this.checkATTPermissionDone}
      />
    );
  }
}
